import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Lock, AlertCircle } from "lucide-react";
import axios from "axios";
import { API, FRONTEND_URL } from "../App";

const AdminLoginScreen = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
      sessionStorage.setItem("admin_token", res.data.token);
      sessionStorage.setItem("admin_user", JSON.stringify({ email: res.data.email, name: res.data.name }));
      navigate("/admin");
    } catch (err) {
      setError(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: "hsl(220, 70%, 8%)" }}>
      <div className="w-full max-w-md px-4">
        <div className="text-center mb-8">
          <img src={`${FRONTEND_URL}/nucarnext-logo.png`} alt="NucarNext" className="h-10 mx-auto mb-6" />
          <h1 className="text-2xl font-semibold text-white">Admin Portal</h1>
          <p className="text-slate-400 text-sm mt-1">Sign in to access the dashboard</p>
        </div>

        <form onSubmit={handleLogin} className="bg-white rounded-2xl p-8 shadow-2xl space-y-5" data-testid="admin-login-form">
          {error && (
            <div className="flex items-center gap-2 p-3 bg-red-50 rounded-xl text-sm text-red-700" data-testid="login-error">
              <AlertCircle className="w-4 h-4 flex-shrink-0" />
              {error}
            </div>
          )}

          <div>
            <label className="text-label mb-1.5 block">EMAIL</label>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter email"
              className="h-12 rounded-xl"
              data-testid="admin-email-input"
              required
            />
          </div>

          <div>
            <label className="text-label mb-1.5 block">PASSWORD</label>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              className="h-12 rounded-xl"
              data-testid="admin-password-input"
              required
            />
          </div>

          <Button type="submit" disabled={loading} className="w-full h-14 btn-primary text-base" data-testid="admin-login-btn">
            {loading ? (
              <span className="flex items-center gap-2">
                <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                Signing in...
              </span>
            ) : (
              <>
                <Lock className="w-5 h-5 mr-2" />
                Sign In
              </>
            )}
          </Button>
        </form>

        <p className="text-center text-slate-500 text-xs mt-6">
          NucarNext Admin — Authorized personnel only
        </p>
      </div>
    </div>
  );
};

export default AdminLoginScreen;
